<template>
    <nav class="navbar sticky-top navbar-expand-lg navbar-light bg-white" style="display: block;">
        <div class="container align-items-center align-items-lg-end">

            <router-link class="navbar-brand" to="/">
                <img src="images/DVS_GSI_SLV_logo.svg" alt="DSV SLV Duisburg Logo" height="30" width=“159” style="margin: 0.188rem 0;">
            </router-link>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#menu" aria-controls="menu"
                aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon">
                    <ul class="buns">
                        <li class="bun"></li>
                        <li class="bun"></li>
                    </ul>
                </span>
            </button>

            <div id="menu" class="collapse navbar-collapse justify-content-center">
                
                <ul class="navbar-nav d-flex align-items-start align-items-lg-end">
                             <div class="d-none d-lg-block nav-link px-0 text-blue">|</div>
                    <li class="nav-item text-center">
                        <router-link :to="{ name: 'home', hash: '#unsere-services' }"
                            @click.native="scrollFix('#unsere-services')" class="nav-link pt-lg-0">Unsere Services
                        </router-link>
                    </li>
                             <div class="d-none d-lg-block nav-link px-0 text-blue">|</div>
                    <li class="nav-item text-center">
                        <router-link :to="{ name: 'home', hash: '#unsere-kompetenzen' }"
                            @click.native="scrollFix('#unsere-kompetenzen')" class="nav-link pt-lg-0">Unsere Kompetenzen
                        </router-link>
                    </li>
         <div class="d-none d-lg-block nav-link px-0 text-blue">|</div>
                    <li class="nav-item text-center">
                        <router-link :to="{ name: 'whitepaper' }" class="nav-link pt-lg-0">Download Infomaterial
                        </router-link>
                    </li>
 <div class="d-none d-lg-block nav-link px-0 text-blue">|</div>
                    <li class="nav-item text-center">
                        <router-link :to="{ name: 'termin' }" class="nav-link pt-lg-0">Jetzt anfragen</router-link>
                    </li>
                     <div class="d-none d-lg-block nav-link px-0 text-blue">|</div>
                    <li class="nav-item d-lg-none">
                        <a class="nav-link pt-lg-0" href="https://www.gsi-slv.de"
                            target="_blank">GSI-SLV.DE</a>
                    </li>
                </ul>

            </div>

            <ul class="justify-content-center align-items-start d-none d-lg-flex">
                <li class="nav-item">
                    <a class="nav-link pt-lg-0" href="https://www.gsi-slv.de" target="_blank">GSI-SLV.DE</a>
                </li>
            </ul>

        </div>
    </nav>
</template>

<style lang="scss" scoped>
    @import 'resources/sass/_variables.scss';

    nav ol,
    nav ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    hr {
        border-top: 1px solid $green;
        // margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .navbar-light .navbar-nav .nav-link.active {
        color: $blue;
        font-weight: 700;
    }

    .navbar-toggler-icon {
        background-image: none !important;
        display: block;
        width: auto !important;
        height: auto !important;
        transition: all 0.2s ease-in-out;
    }

    .navbar-toggler {
        border: none !important;
        padding: 0;
    }

    .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon ul.buns li.bun {
        transform: rotate(45deg) translateZ(0);
    }

    .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon ul.buns li.bun:last-child {
        transform: rotate(-45deg) translateZ(0);
    }

    .navbar-toggler .navbar-toggler-icon ul.buns {
        width: 2.5rem;
        list-style: none;
        padding: 0;
        transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1), color 1s cubic-bezier(0.23, 1, 0.32, 1);
        transform: translateZ(0);
    }

    .navbar-toggler .navbar-toggler-icon ul.buns li.bun {
        width: 100%;
        height: 4px;
        background-color: $blue;
        position: absolute;
        transform: translateY(-3.75px) translateZ(0);
        transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1), background-color 1s cubic-bezier(0.23, 1, 0.32, 1);
    }

    .navbar-toggler .navbar-toggler-icon ul.buns li.bun:last-child {
        transform: translateY(3.75px) translateZ(0);
    }

    .navbar-light .navbar-nav .nav-link {
        font-size: 1rem;
        color: $blue;
        transition: all 0.2s ease-in-out;
    }

    .nav-link:hover,
    .navbar-light .navbar-nav .nav-link:hover {
        color: $green;
    }

</style>

<script>
    export default {
        mounted: function () {
            // From testing, without a brief timeout, it won't work.
            // setTimeout(() => this.scrollFix(this.$route.hash), 1);
        },
        methods: {
            scrollFix: function (hashbang) {
                setTimeout(function () {
                    location.hash = '';
                    location.hash = hashbang;
                }, 500);
            }
        }
    }

</script>
